import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import * as _ from 'lodash';
import {MotivoDesligamentoService} from 'src/app/services/motivo-desligamento/motivo-desligamento.service';
import {MotivoDesligamento} from 'src/app/core/motivo-desligamento';

@Component({
    selector: 'combo-motivo-desligamento',
    templateUrl: './combo-motivo-desligamento.component.html',
    styleUrls: ['./combo-motivo-desligamento.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class ComboMotivoDesligamentoComponent implements OnInit {

    @ViewChild('comboMotivoDesligamento', {static: false}) comboMotivoDesligamento;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private motivoDesligamentoService: MotivoDesligamentoService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        // Carrega motivos de desligamento dinamicamente do serviço
        this.motivoDesligamentoService.getAll().subscribe((motivos: MotivoDesligamento[]) => {
            this.dados = motivos;
            this.preencherCombo();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.preencherCombo();
    }

    private preencherCombo() {
        if (this.selecionado && this.dados.length) {
            if (typeof this.selecionado === 'number' || typeof this.selecionado === 'string') {
                this.selecionado = _.find(this.dados, {id: this.selecionado});
            }
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }

}
